import { render, staticRenderFns } from "./product_group.vue?vue&type=template&id=32e9ea8f&"
import script from "./product_group.vue?vue&type=script&lang=js&"
export * from "./product_group.vue?vue&type=script&lang=js&"
import style0 from "./product_group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
